import { Box, Tab, Tabs } from "@mui/material";
import { Outlet, useMatches, useNavigate } from "react-router";
import { useMemo } from "react";

export function CasePropertiesHeader() {
  const matches = useMatches();
  const value = useMemo(
    () =>
      matches.find((m) => m.id === "lens-editor/lens/properties-case")
        ? "case"
        : matches.find((m) => m.id === "lens-editor/lens/properties-groups")
          ? "groups"
          : matches.find((m) => m.id === "lens-editor/lens/properties-locations")
            ? "locations"
            : "calcs",
    [matches]
  );
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", px: 1 }}>
      <Tabs
        value={value}
        onChange={(_evt, value) => {
          navigate(`./${value}`);
        }}>
        <Tab label="Case" value="case" />
        <Tab label="Calcs" value="calcs" />
        <Tab label="Groups" value="groups" />
        <Tab label="Locations" value="locations" />
      </Tabs>
      <Box sx={{ minHeight: 0 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
